<!--<template>-->
<!--  <VaNavbar class="app-layout-navbar py-2 px-0">-->
<!--    <template #left>-->
<!--      <div class="left">-->
<!--        <Transition v-if="isMobile" name="icon-fade" mode="out-in">-->
<!--          <VaIcon-->
<!--            color="primary"-->
<!--            :name="isSidebarMinimized ? 'menu' : 'close'"-->
<!--            size="24px"-->
<!--            style="margin-top: 3px"-->
<!--            @click="isSidebarMinimized = !isSidebarMinimized"-->
<!--          />-->
<!--        </Transition>-->
<!--        <RouterLink to="/" aria-label="Visit home page">-->
<!--          <VuesticLogo />-->
<!--        </RouterLink>-->
<!--      </div>-->
<!--    </template>-->
<!--    <template #right>-->
<!--      <AppNavbarActions class="app-navbar__actions" :is-mobile="isMobile" />-->
<!--    </template>-->
<!--  </VaNavbar>-->
<!--</template>-->

<!--<script setup lang="ts">-->
<!--import { storeToRefs } from 'pinia'-->
<!--import { useGlobalStore } from '../../stores/global-store'-->
<!--import AppNavbarActions from './components/AppNavbarActions.vue'-->
<!--import VuesticLogo from '../VuesticLogo.vue'-->

<!--defineProps({-->
<!--  isMobile: { type: Boolean, default: false },-->
<!--})-->

<!--const GlobalStore = useGlobalStore()-->

<!--const { isSidebarMinimized } = storeToRefs(GlobalStore)-->
<!--</script>-->

<!--<style lang="scss" scoped>-->
<!--.va-navbar {-->
<!--  z-index: 2;-->

<!--  @media screen and (max-width: 950px) {-->
<!--    .left {-->
<!--      width: 100%;-->
<!--    }-->

<!--    .app-navbar__actions {-->
<!--      display: flex;-->
<!--      justify-content: space-between;-->
<!--    }-->
<!--  }-->
<!--}-->

<!--.left {-->
<!--  display: flex;-->
<!--  align-items: center;-->
<!--  margin-left: 1rem;-->

<!--  & > * {-->
<!--    margin-right: 1rem;-->
<!--  }-->

<!--  & > *:last-child {-->
<!--    margin-right: 0;-->
<!--  }-->
<!--}-->

<!--.icon-fade-enter-active,-->
<!--.icon-fade-leave-active {-->
<!--  transition: transform 0.5s ease;-->
<!--}-->

<!--.icon-fade-enter,-->
<!--.icon-fade-leave-to {-->
<!--  transform: scale(0.5);-->
<!--}-->
<!--</style>-->

<template>
  <VaNavbar class="app-layout-navbar py-2 px-0">
    <template #left>
      <div class="left">
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            color="primary"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            style="margin-top: 3px"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>
        <RouterLink to="/" aria-label="Visit home page">
          <img src="/logo_new.png" alt="Logo" class="h-6" />
          <!--          <span class="font-bold text-xl ml-2">Admin Panel</span>-->
        </RouterLink>
      </div>
    </template>

    <template #right>
      <VaButton preset="primary" icon="logout" aria-label="Log out" class="mr-4" @click="onLogout" />
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '@/stores/global-store'
import { useAuthStore } from '@/stores/auth'
import { logoutSuperadmin } from '@/services/auth'
import { useRouter } from 'vue-router'
import { useToast, VaNavbar, VaButton, VaIcon } from 'vuestic-ui'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const { isSidebarMinimized } = storeToRefs(useGlobalStore())
const authStore = useAuthStore()
const router = useRouter()
const toast = useToast()

const onLogout = async () => {
  try {
    await logoutSuperadmin()
  } catch (e) {
    // Даже если API упадёт — всё равно логаутим локально
    toast.init({ message: 'Logout failed on server, but you were logged out locally.', color: 'warning' })
  } finally {
    authStore.logout()
    await router.push({ name: 'superadmin-login' })
  }
}
</script>

<style lang="scss" scoped>
.va-navbar {
  z-index: 2;

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;

  & > * {
    margin-right: 1rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}
</style>
